/**
 * Unwraps the unifier envelope for one service.
 *
 * Two things vary, and both are polus config rather than service behaviour:
 *
 *  - the DynamicRoute's `transformation` decides whether `responseBody` is keyed by
 *    ServiceDefinition id or flattened to the payload. This reads the KEYED shape, which is
 *    what dev, staging and prod all return — they are deliberately configured without the
 *    field. `NO_TRANSFORMATION` would flatten it (UnifierServiceImpl returns the map
 *    untouched only when the field is null), and this would then read `{}`: no recipients,
 *    and every successful send reported as a failure.
 *  - the same setting on the ServiceDefinition decides whether that service's own
 *    `{success, statusCode, data}` wrapper survives, which is why `.data` is a fallback and
 *    not a given.
 *
 * @param res - the axios response from a unifier call
 * @param serviceId - the ServiceDefinition id this call fans out to
 * @returns the service's payload, or `{}` when the envelope carries nothing usable
 */
export const unwrap = (res: any, serviceId: string): any => {
    const entry = res?.data?.responseBody?.[serviceId];
    if (!entry || typeof entry !== 'object') return {};
    return entry.data && typeof entry.data === 'object' ? entry.data : entry;
};
